import { ReactNode, useCallback } from 'react'

import { Member } from '@tribeplatform/gql-client/types'
import { Avatar } from '@tribeplatform/react-ui-kit/Avatar'
import { Tooltip } from '@tribeplatform/react-ui-kit/Tooltip'

import { analyticsNumberFormatter } from '../../../Analytics/utils/index.js'
import {
  MemberAvatar,
  MemberAvatarProps,
} from '../../../common/components/index.js'
import { cn } from '../../../utils/cn.js'

interface Props {
  members: Member[]
  avatarSize?: MemberAvatarProps['size']
  visibleCount?: number
  className?: string
  plusTooltip?: ReactNode
  totalCount: number
}

export const MemberAvatars = ({
  members = [],
  avatarSize,
  className,
  visibleCount = 2,
  totalCount,
  plusTooltip,
}: Props) => {
  const visibleItems = members.slice(0, visibleCount)
  const hasMore = totalCount > visibleCount
  const plusCount = totalCount - visibleCount

  const plusCountRendered = useCallback(() => {
    return (
      // eslint-disable-next-line react/jsx-no-literals
      <span className="text-content-subdued p-1 text-xs">
        +{analyticsNumberFormatter(plusCount)}
      </span>
    )
  }, [plusCount])

  if (visibleItems.length === 0) {
    return null
  }
  return (
    <div className={cn(className)}>
      <div className="flex -space-x-2 items-stretch">
        {visibleItems.map(member => (
          <div key={member.id}>
            <Tooltip>
              <Tooltip.Trigger>
                <MemberAvatar
                  member={member}
                  size={avatarSize}
                  className="border overflow-hidden"
                />
              </Tooltip.Trigger>
              <Tooltip.Panel>{member.name}</Tooltip.Panel>
            </Tooltip>
          </div>
        ))}
        {hasMore && (
          <Tooltip>
            <Tooltip.Trigger>
              <Avatar
                className={cn(
                  'cursor-pointer flex text-content-subdued justify-center items-center min-w-min bg-surface-subdued',
                )}
                size={avatarSize}
                fallback={plusCountRendered}
              />
            </Tooltip.Trigger>
            <Tooltip.Panel>{plusTooltip}</Tooltip.Panel>
          </Tooltip>
        )}
      </div>
    </div>
  )
}
